<template>
  <div class="submission-details details" :class="mediaListClasses">
    <div class="close" v-on:click="close()">
      <b-icon icon="close" size="is-large" />
    </div>
    <div class="application-details">
      <personal-details :submission="submission">
        <div class="addresses">
          <address-card
            :address="submission.address"
            :submission="submission"
            :countries="countries"
            :mayEdit="mayEdit"
            type="postal"
            :primaryPostal="showSecondaryAddress"
          ></address-card>
          <address-card
            v-if="showSecondaryAddress && submission.hasCollectionAddress"
            :address="submission.collectionAddress"
            :subId="submission._id"
            :countries="countries"
            type="collection"
          ></address-card>
        </div>
      </personal-details>
      <status-summary :submission="submission"></status-summary>
    </div>
    <div class="media-items row horizontal">
      <media-card
        v-for="mi in mediaItems"
        :item="mi.item"
        :work="mi.work"
        :key="mi.key"
        :selected="selectedMediaId"
        :subId="subId"
        :class="mi.classNames"
      />
<!--       <div class="card text-item">
        <div class="item-info" @click="addNew(mi.work._id)">
          <div class="media-info">
            <h4 class="title"><span class="label">Work</span><span class="text">{{mi.work.title}}</span></h4>
            <h5 class="year" v-if="mi.work.year > 1000"><span class="label">Year</span><span class="text">{{mi.work.year}}</span></h5>
            <h5 class="medium" v-if="hasStringValue(mi.work.medium)"><span class="label">Medium</span><span class="text">{{mi.work.medium}}</span></h5>
            <div class="text-preview" v-html="mi.work.description"></div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="work-actions">

      <div class="card add-work-media" @click="addNew">
        <b-icon icon="plus" size="is-large" />
        <span class="label">Add new work.</span>
      </div>
      <div v-if="hasInvalidWorks" class="card invalid-works">
        <p>Incomplete works:</p>
        <ol class="incomplete-works">
          <li
            v-for="w in submission.invalidWorks"
            :key="w._id"
            @click="addNew(w._id)"
            class="edit-incomplete"
            title="Edit work"
          >{{w.title}}</li>
        </ol>
        <span @click="deleteInvalid" class="control-wrapper">
          <b-icon icon="trash-can-outline" size="is-medium" title="Delete all incomplete works" />
        </span>
      </div>
    </div>
    <div class="media-overlay" :class="mediaOverlayClasses">
      <template v-if="hasSelectedMediaId">
        <media-card
          v-if="!newMode"
          :item="selectedMediaItem.item"
          :work="selectedMediaItem.work"
          :selected="selectedMediaId"
          :mayEdit="mayEdit"
          :subId="subId"
        />
        <work-media-edit v-if="newMode" :work="newWork" />
        <div v-if="showPrev" class="arrow prev" @click="prev">
          <b-icon icon="chevron-left" size="is-large" />
        </div>
        <div v-if="showNext" class="arrow next" @click="next">
          <b-icon icon="chevron-right" size="is-large" />
        </div>
      </template>
    </div>
    <div class="mail-info">
      <h3>
        Emails sent to
        <a :href="email|mailto">{{email}}</a>
      </h3>
      <ol v-if="hasMail">
        <li v-for="mail in mails" :key="mail.transactionid">
          <span class="type">{{mail.key|toWords}}</span>
          <time>{{mail.datetime|shortDatetime}}</time>
        </li>
      </ol>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { bus } from "../main";
import filters from "../mixins/filters";
import { submissionSchema } from "../store/submission";
import AddressCard from "./AddressCard";
import MediaCard from "./MediaCard";
import PersonalDetails from "./PersonalDetails";
import StatusSummary from "./StatusSummary";
import WorkMediaEdit from "./WorkMediaEdit";
import { workSchema } from "../store/schemas";
import { getMailsByEmail } from "../api/methods";
import { notEmptyString } from "../api/helpers";

export default {
  name: "SubmissionDetail",
  components: {
    MediaCard,
    AddressCard,
    PersonalDetails,
    StatusSummary,
    WorkMediaEdit
  },
  props: {
    submission: {
      type: Object,
      default() {
        return submissionSchema;
      }
    }
  },
  mixins: [filters],
  created() {
    this.showSecondaryAddress = this.settings.show_collection_address !== false;
    bus.$on("media-item-updated", this.triggerUpdate);
    bus.$on("update-media-item", this.triggerUpdate);
    bus.$on("work-updated", this.triggerUpdate);
    bus.$on("escape", this.cancel);
    bus.$on("next", this.handleNext);
    bus.$on("prev", this.handlePrev);
  },
  mounted() {
    setTimeout(() => {
      const { path } = this.$route;
      const parts = path.substring(1).split("/");
      this.selectedMediaId = "";
      if (parts.length > 2) {
        if (parts[2].length > 3) {
          if (parts[2].indexOf("work-") === 0) {
            const wId = parts[2].split("-").pop();
            let w = this.submission.works.find(w => w._id === wId);
            if (!w) {
              w = this.submission.invalidWorks.find(w => w._id === wId);
            }
            if (w) {
              this.newWork = w;
              this.selectedMediaId = "new";
            }
          } else {
            this.selectedMediaId = parts[2];
            this.newWork = workSchema;
          }
        }
      }
    }, 500);
    setTimeout(this.loadMails, 1500);
  },
  beforeDestroy() {
    bus.$off("media-item-updated", this.triggerUpdate);
    bus.$off("work-updated", this.triggerUpdate);
    bus.$off("escape", this.cancel);
    bus.$off("next", this.handleNext);
    bus.$off("prev", this.handlePrev);
  },
  data() {
    return {
      selectedMediaId: "",
      showSecondaryAddress: true,
      newWork: {
        _id: "",
        ...workSchema
      },
      hasMail: false,
      mails: [],
      numMails: 0
    };
  },
  computed: {
    ...mapGetters(["settings", "options", "countries", "user"]),
    mediaItems() {
      let items = [];
      const { works, numWorks } = this.submission;
      if (works instanceof Array && numWorks > 0) {
        let ids = [];
        const filterFunc = w => {
          let valid = w.mediaItems.length > 0 || notEmptyString(w.description, 4);
          if (valid && this.filterBySelected) {
            valid = w.selected;
          }
          return valid;
        };
        works
          .filter(filterFunc)
          .map((w, wi) => {
            w.index = wi;
            return w;
          })
          .forEach((w, wi) => {
            let numItems = 0;
            if (w.mediaItems instanceof Array) {
              w.mediaItems.forEach((item, mi) => {
                if (ids.indexOf(item._id) < 0) {
                  const isFirst = mi === 0;
                  const isFirstClass = isFirst ? 'is-first' : 'is-extra';
                  const classNames = [`work-${(wi+1)}`, `item-${(mi+1)}`, isFirstClass];
                  
                  const key = [item.filename, wi, mi].join('-')
                  const { _id } = item;
                  if (_id) {
                    items.push({ _id, item, work: w, classNames, key, isFirst, isEmpty: false });
                    ids.push(_id);
                    numItems++;
                  }
                }
              });
            }
            if (numItems < 1) {
              const classNames = [`work-${(wi+1)}`, `item-1`, 'is-first'];
              
              const key = ['empty-work', wi, 0].join('-')
              const item = {
                _id: 'work-' + w._id,
                filename: '',
                type: '',
                mime: '',
                source: '',
                size: 0,
                title: ''
              };
              items.push({ item, work: w, classNames, key, isFirst: true, isEmpty: true });
            }
          });
      }
      return items;
    },
    works() {
      const { works, numWorks } = this.submission;
      if (works instanceof Array && numWorks > 0) {
        return works;
      } else {
        return [];
      }
    },
    mediaListClasses() {
      let cls = this.hasSelectedMediaId ? ["show-selected"] : ["show-list"];
      cls.push("num-items-" + this.mediaItems.length);
      return cls;
    },
    hasSelectedMediaId() {
      return (
        this.selectedMediaId === "new" ||
        (notEmptyString(this.selectedMediaId, 3) &&
          this.mediaItems.map(mi => mi._id).indexOf(this.selectedMediaId) >= 0)
      );
    },
    selectedMediaItem() {
      return this.mediaItems.find(mi => mi._id === this.selectedMediaId);
    },
    mayEdit() {
      return this.user.role === "admin";
    },
    subId() {
      let str = "";
      if (this.submission) {
        if (this.submission._id) {
          str = this.submission._id;
        }
      }
      return str;
    },
    email() {
      let email = "";
      const { user } = this.submission;
      if (user instanceof Object) {
        email = user.identifier;
      }
      return email;
    },
    showPrev() {
      return this.mediaItems.length > 1;
    },
    showNext() {
      return this.mediaItems.length > 1;
    },
    newMode() {
      return this.selectedMediaId === "new";
    },
    mediaOverlayClasses() {
      let cls = this.hasSelectedMediaId ? ["has-selected"] : ["none-selected"];
      if (this.newMode) {
        cls.push("is-new");
      }
      return cls;
    },
    hasInvalidWorks() {
      if (this.submission.numAllWorks) {
        return this.submission.invalidWorks.length > 0;
      }
      return false;
    },
    filterBySelected() {
      return this.$parent.primaryFilter === "selected";
    }
  },
  methods: {
    showFull(mi, workId) {
      this.selectedMediaId = this.selectedMediaId === mi._id ? "" : mi._id;
      let newPath = "/submissions/" + this.submission._id;
      if (notEmptyString(this.selectedMediaId, 5)) {
        newPath += "/" + this.selectedMediaId;
      } else {
        if (notEmptyString(workId, 5)) {
          newPath += "/" + workId;
        }
      }
      if (this.$route.path !== newPath) {
        this.$router.push({
          path: newPath,
          query: this.$route.query
        });
      }
      this.$scrollTo("body", 250);
    },
    matchWork(item) {
      if (item instanceof Object && this.submission.works instanceof Array) {
        return this.submission.works.find(w =>
          w.mediaItems.some(mi => mi._id === item._id)
        );
      }
    },/* 
    matchMediaItems(workIndex = 0) {
      return this.mediaItems.filter()
    }, */
    close() {
      if (notEmptyString(this.selectedMediaId, 2)) {
        this.selectedMediaId = "";
        const { path, query } = this.$route;
        this.newWork = workSchema;
        const parts = path.substring(1).split("/");
        if (parts.length > 2) {
          parts.pop();
          const newPath = "/" + parts.join("/");
          this.$router.push({
            path: newPath,
            query
          });
        }
      } else {
        this.$parent.close();
      }
    },
    next(prev) {
      const lastIndex = this.mediaItems.length - 1;
      const index = this.mediaItems.findIndex(
        mi => mi._id === this.selectedMediaId
      );
      if (index >= 0) {
        let nextIndex = prev === true ? index - 1 : index + 1;
        if (nextIndex < 0) {
          nextIndex = lastIndex;
        } else if (nextIndex > lastIndex) {
          nextIndex = 0;
        }
        this.selectedMediaId = this.mediaItems[nextIndex]._id;
      }
    },
    prev() {
      return this.next(true);
    },
    addNew(workId) {
      this.selectedMediaId = "new";
      const { path, query } = this.$route;
      const lastParam = notEmptyString(workId, 5)
        ? ["work", workId].join("-")
        : "new-work";
      const newPath = "/submissions/" + this.subId + "/" + lastParam;
      if (path !== newPath) {
        this.$router.push({
          path: newPath,
          query
        });
      }
      this.$scrollTo("body", 250);
    },
    deleteInvalid() {
      this.$parent.deleteInvalidWorks(this.submission);
    },
    loadMails() {
      if (this.submission) {
        const { user } = this.submission;
        if (user) {
          getMailsByEmail(user.identifier).then(data => {
            if (data.valid) {
              this.mails = data.mails;
              this.numMails = this.mails.length;
              this.hasMail = this.numMails > 0;
            }
          });
        }
      }
    },
    isDetailPath() {
      const { path } = this.$route;
      return /^\/submissions\/\w{12,32}/.test(path);
    },
    cancel(val) {
      if (val && this.isDetailPath()) {
        this.selectedMediaId = "";
        const { path } = this.$route;
        const parts = path.substring(1).split("/");
        if (parts.length > 2 && parts[0] === "submissions") {
          parts.pop();
          this.$router.push("/" + parts.join("/"));
          this.newWork = workSchema;
        }
      }
    },
    triggerUpdate() {
      setTimeout(() => {
        this.$forceUpdate();
      }, 500);
    },
    handleNext(val) {
      if (val && this.isDetailPath()) {
        this.next();
      }
    },
    handlePrev(val) {
      if (val && this.isDetailPath()) {
        this.prev();
      }
    },
    hasStringValue(val) {
      return notEmptyString(val, 1);
    }
  }
};
</script>
